import PropTypes from 'prop-types';
import styles from './FJBlankPanel.module.less';
import emptyBase64 from '../../../assets/base64/empty.js';

const FJBlankPanel = props => {
    // const { icon, text } = props;
    const { text } = props;
    return (
        <div className={styles.blank}>
            {/* {icon} */}
            <img className={styles.blank_img} src={emptyBase64} />
            <span className={styles.blank_text}>{text}</span>
        </div>
    );
};

FJBlankPanel.propTypes = {
    icon: PropTypes.node,
    text: PropTypes.string,
};
export default FJBlankPanel;
